export default "__VITE_ASSET__DrVCai4M__"